"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _jsLogger = _interopRequireDefault(require("@sfly/js-logger"));

var _helperUtil = require("./helperUtil");
/* eslint-disable no-param-reassign */


var UIG_UNIVERSAL_HEADER = 'UIG_UNIVERSAL_HEADER';
var URL_KEY = 'URL';
var CALLING_CLASS_KEY = 'callingClass';
var CALLING_METHOD_KEY = 'callingMethod';
var ERROR_KEY = 'error';
var HTTP_RESPONSE_KEY = 'httpResponse';
var LOGGING_LOCATION_SUFFIX = '/application/log.gif';
/* eslint-disable no-console */

/**
 * Todo: implement more Logger method @sfly/js-logger if needed
 */

var Logger = /*#__PURE__*/function () {
  function Logger(callingClassName) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : UIG_UNIVERSAL_HEADER;
    (0, _classCallCheck2.default)(this, Logger);
    this.callingClassName = callingClassName;
    this.logger = (0, _jsLogger.default)(name, {
      resource: (0, _helperUtil.getDomainUrl)('SFLY') + LOGGING_LOCATION_SUFFIX
    });
  }
  /**
   * Add extra logging data
   * @param message
   * @param callingMethod
   * @param error
   * @param httpResponse
   * @param additionalData
   */


  (0, _createClass2.default)(Logger, [{
    key: "appendExtraLoggingData",
    value: function appendExtraLoggingData(additionalData, callingMethod, error, httpResponse) {
      if (typeof window !== 'undefined') {
        additionalData[URL_KEY] = window.location.href;
      }

      additionalData[CALLING_CLASS_KEY] = this.callingClassName;

      if (callingMethod) {
        additionalData[CALLING_METHOD_KEY] = callingMethod;
      }

      if (error) {
        additionalData[ERROR_KEY] = (0, _stringify.default)(error);
      }

      if (httpResponse) {
        additionalData[HTTP_RESPONSE_KEY] = (0, _stringify.default)(httpResponse);
      }
    }
    /**
     * Log debug info by calling SFLY logger API
     * @param message
     * @param callingMethod
     * @param error
     * @param httpResponse
     * @param additionalData
     */

  }, {
    key: "debug",
    value: function debug(message, callingMethod, error, httpResponse) {
      var additionalData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      this.appendExtraLoggingData(additionalData, callingMethod, error, httpResponse);
      this.logger.debug(message, additionalData);
      (0, _helperUtil.consoleDebug)(message, additionalData);
    }
    /**
     * Log info by calling SFLY logger API
     * @param message
     * @param callingMethod
     * @param error
     * @param httpResponse
     * @param additionalData
     */

  }, {
    key: "info",
    value: function info(message, callingMethod, error, httpResponse) {
      var additionalData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      this.appendExtraLoggingData(additionalData, callingMethod, error, httpResponse);
      this.logger.info(message, additionalData);
      (0, _helperUtil.consoleInfo)(message, additionalData);
    }
    /**
     * Log warning by call SFLY logginer API
     * @param message
     * @param callingMethod
     * @param error
     * @param httpResponse
     * @param additionalData
     */

  }, {
    key: "warn",
    value: function warn(message, callingMethod, error, httpResponse) {
      var additionalData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      this.appendExtraLoggingData(additionalData, callingMethod, error, httpResponse);
      this.logger.warn(message, additionalData);
      (0, _helperUtil.consoleWarn)(message, additionalData);
    }
    /**
     * Log error by calling SFLY logger API
     * @param message
     * @param callingMethod
     * @param error
     * @param httpResponse
     * @param additionalData
     */

  }, {
    key: "error",
    value: function error(message, callingMethod, _error, httpResponse) {
      var additionalData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      this.appendExtraLoggingData(additionalData, callingMethod, _error, httpResponse);
      this.logger.error(message, additionalData);
      (0, _helperUtil.consoleLog)(message, additionalData);
    }
  }]);
  return Logger;
}();

exports.default = Logger;